import React from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'
import parse from 'html-react-parser'

const DecisionMakingConclusion = () => {
  const { trackContent } = useExercise()
  const { t } = useTranslation('decision_making.summary')
  const values = trackContent['selected_values']
  const valueImportance = trackContent['value_importance']
  const positions = trackContent['positions']
  const scoredOptions = trackContent['scored_options']

  const calcScores = () => {
    const scoresHash = {}

    positions.forEach((position) => {
      const scores = scoredOptions
        .filter((option) => option['position'] === position)
        .map((option) => option.score)

      const importances = scoredOptions
        .filter((option) => option['position'] === position)
        .map((option) => option.importance)
      let total = 0

      scores.map((score, idx) => (total += score * importances[idx]))
      scoresHash[position] = total
    })

    return scoresHash
  }

  const highestScore = Object.values(calcScores()).sort((a, b) => b - a)[0]
  const bestPosition = Object.keys(calcScores()).find(
    (key) => calcScores()[key] === highestScore,
  )

  const getImportance = (value) => {
    if (value === 3) {
      return 'Critical'
    } else if (value === 2) {
      return 'Important'
    } else {
      return 'Less Important'
    }
  }
  return (
    <div className="flex flex-col gap-4">
      <p>{t('description')}</p>
      <h2>{t('details_h2')}</h2>
      <p>{t('summary_description')}</p>
      <h3>{t('values_ranking')}</h3>
      <ul>
        {values.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
      <h3>{t('values_importance')}</h3>
      <ul>
        {values.map((value, index) => (
          <li
            key={index}
          >{`${value}: ${getImportance(valueImportance[value])}`}</li>
        ))}
      </ul>
      <h3>{t('career_score')}</h3>
      <p>{t('score_description')}</p>
      <p>
        {parse(t('highest_position_html'))}: {bestPosition}
      </p>
      <ul>
        {positions.map((position, index) => (
          <li key={index}>
            {position}: {calcScores()[position]}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DecisionMakingConclusion
